import { Button } from '@deque/cauldron-react'
import React from 'react'
import { useAsync } from 'react-async-hook'
import {
  useCookiePermission,
  setAllowCookies,
  setUserHasResponded,
  readFromStorage,
} from '../../context/CookiePermission'
import './index.scss'
import { useTranslation } from 'react-i18next'

export default function CookieNotice() {
  const { state, dispatch } = useCookiePermission()
  const asyncRead = useAsync(readFromStorage, [dispatch])
  const { t } = useTranslation()

  const onAcceptEssential = () => {
    setUserHasResponded(dispatch, true)
    setAllowCookies(dispatch, false)
  }

  const onAcceptAll = () => {
    setUserHasResponded(dispatch, true)
    setAllowCookies(dispatch, true)
  }

  const content = (
    <div className="CookieNotice" role="complementary" data-nosnippet>
      <h1>
        <span>{t('cookieNotice.title')}</span>
      </h1>
      <div className="CookieNotice__Content">
        <p>
          {t('cookieNotice.content')}{' '}
          <a href="https://deque.com/privacy-policy/">
            {t('cookieNotice.privacyPolicy')}
          </a>
          .
        </p>
        <p>
          {t('cookieNotice.byClicking')}{' '}
          <strong>{t('cookieNotice.buttons.acceptAll')}</strong>{' '}
          {t('cookieNotice.youConsent')}
        </p>
      </div>
      <div className="CookieNotice__Buttons">
        <Button variant="secondary" onClick={onAcceptEssential}>
          {t('cookieNotice.buttons.acceptEssential')}
        </Button>
        <Button onClick={onAcceptAll}>
          {t('cookieNotice.buttons.acceptAll')}
        </Button>
      </div>
    </div>
  )

  return (
    <>
      {asyncRead.loading && null}
      {asyncRead.status === 'success' && !state.userHasResponded && content}
    </>
  )
}
